import { EvaluationResponse } from '@module/evaluation/model/EvaluationResponse';
import { EvaluationAvailableChartererAccountItemsOverviewResponse } from '@module/evaluation/model/EvaluationAvailableChartererAccountItemsOverviewResponse';
import { evaluationApi } from '../api';

export const chartererAccountApi = evaluationApi.injectEndpoints({
  endpoints: (build) => ({
    submitChartererAccountReport: build.mutation<
      EvaluationResponse,
      { evaluationId: string | number }
    >({
      query: ({ evaluationId }) => ({
        url: `/${evaluationId}/submit-charterer-account-report`,
        method: 'GET'
      }),
      invalidatesTags: (res, _err, { evaluationId }) =>
        res ? [{ type: 'EVALUATION', id: evaluationId }] : ['EVALUATION']
    }),

    loadAvailableChartererAccountExpenses: build.query<
      EvaluationAvailableChartererAccountItemsOverviewResponse,
      { evaluationId: string | number }
    >({
      query: ({ evaluationId }) => ({
        url: `/${evaluationId}/load-available-charterer-account-expenses`,
        method: 'GET'
      })
    })
  }),
  overrideExisting: false
});

export const {
  useSubmitChartererAccountReportMutation,
  useLazyLoadAvailableChartererAccountExpensesQuery
} = chartererAccountApi;
